import { tokens } from '@fluentui/react-components';
import { EProjectStatus, EProjectView } from './types';

export const PROJECTS_ENDPOINT = '/projects';
export const PROJECTS_QUERY_KEY = 'projects';
export const PROJECT_QUERY_KEY = 'project';
export const PROJECTS_TABLE_ID = 'projects-table';

export const DEFAULT_PROJECT_FILTER_STATUSES: EProjectStatus[] = [EProjectStatus.PLANNING, EProjectStatus.ACTIVE];
// Keep an explicit cleared filter distinct from the initial selection in the URL.
export const PROJECT_ALL_STATUSES_FILTER = 'all';
// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/projects/configs/projects.config.ts
export const PROJECT_SEARCH_MAX_LENGTH = 200;
// Give project details a wider, bounded content area.
export const PROJECT_DETAILS_MAX_WIDTH_PX = 1440;
export const PROJECT_VIEW_PARAM = 'view';
export const DEFAULT_PROJECT_VIEW = EProjectView.TASKS;

// One hue family per status, shared by the badge and the square: the badges use Fluent's tint
// presets (informative/success/danger) plus one custom blue pair, and each filled square uses
// the SAME family's strong tone, so no colour exists outside these four families.
export const PROJECT_STATUS_METADATA: Record<EProjectStatus, { label: string; squareColor: string }> = {
  [EProjectStatus.PLANNING]: { label: 'Planning', squareColor: tokens.colorNeutralForeground3 },
  [EProjectStatus.ACTIVE]: { label: 'Active', squareColor: tokens.colorPaletteBlueBorderActive },
  [EProjectStatus.COMPLETED]: { label: 'Completed', squareColor: tokens.colorPaletteGreenBackground3 },
  [EProjectStatus.CANCELLED]: { label: 'Cancelled', squareColor: tokens.colorPaletteRedBackground3 },
};
export const PROJECT_STATUSES = Object.values(EProjectStatus).map((value) => ({
  value,
  ...PROJECT_STATUS_METADATA[value],
}));

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/projects/configs/projects.config.ts
export const PROJECT_DESCRIPTION_MAX_LENGTH = 10000;
export const PROJECT_PARTICIPANTS_MAX = 200;
// Space above the table (nav, title, filters) - keeps the list within the screen.
// LITERATURES_UI_MARGIN_TOP minus one 50px row: projects has one filter row where literature has two,
// and keeping the margins exactly one row apart makes both lists end on the same line at any window height.
export const PROJECTS_UI_MARGIN_TOP = 365;
